var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup1176(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(-363 -1322)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(363 1322)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rating",
    transform: "translate(373.308 1332.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1866",
    "data-name": "Path 1866",
    d: "M171.921,11.058l4.329,2.276-.827-4.821,3.5-3.415-4.842-.7L171.921,0l-2.165,4.395-4.842.7,3.5,3.415-.827,4.821Zm0,0",
    transform: "translate(-152.228)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1867",
    "data-name": "Path 1867",
    d: "M336.111,106.492l-2.165-4.387-2.165,4.387-4.84.7,3.5,3.414-.827,4.822,4.329-2.276,4.332,2.276-.829-4.822,3.729-3.414Zm0,0",
    transform: "translate(-301.792 -94.251)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1868",
    "data-name": "Path 1868",
    d: "M3.729,110.609,2.9,115.431l4.332-2.276,4.329,2.276-.827-4.822,3.5-3.414-4.84-.7-2.165-4.387-2.165,4.387-5.067.7Zm0,0",
    transform: "translate(0 -94.251)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    "data-name": "Path 1869",
    d: "M192.539,216.769a5.769,5.769,0,1,0-5.769,5.769A5.776,5.776,0,0,0,192.539,216.769Zm0,0",
    transform: "translate(-167.077 -194.769)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    "data-name": "Path 1870",
    d: "M151,369.077v3.539h16.154v-3.539a8.077,8.077,0,0,0-16.154,0Zm0,0",
    transform: "translate(-139.384 -333.23)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    "data-name": "Path 1871",
    d: "M391.336,426.769A5.776,5.776,0,0,0,385.566,421a5.69,5.69,0,0,0-1.7.286,10.241,10.241,0,0,1,.549,3.176V428h6.923Zm0,0",
    transform: "translate(-354.335 -388.615)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    "data-name": "Path 1872",
    d: "M355.231,305.616a4.615,4.615,0,1,0-9.231,0c0,.147.03.286.043.429a10.382,10.382,0,0,1,2.645,3.751,4.567,4.567,0,0,0,1.927.435A4.62,4.62,0,0,0,355.231,305.616Zm0,0",
    transform: "translate(-319.384 -277.846)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1873",
    "data-name": "Path 1873",
    d: "M55.188,306.044c.014-.143.043-.282.043-.429a4.615,4.615,0,1,0-4.615,4.616,4.571,4.571,0,0,0,1.927-.435A10.381,10.381,0,0,1,55.188,306.044Zm0,0",
    transform: "translate(-42.462 -277.846)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1874",
    "data-name": "Path 1874",
    d: "M31,426.769V428h6.923v-3.539a10.24,10.24,0,0,1,.549-3.176,5.689,5.689,0,0,0-1.7-.286A5.776,5.776,0,0,0,31,426.769Zm0,0",
    transform: "translate(-28.615 -388.615)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup1176);
export default __webpack_public_path__ + "static/media/Group 1176.1d72335f3f157a3f9255ae7c42b9d938.svg";
export { ForwardRef as ReactComponent };